export const menuTabSet = {
  RACE_SUMMARY: "race summary",

  ENTRIES: "entries",

  RACE_CARD: "race card",

  //odds
  CURRENT_ODDS: "current odds",
  REFERENCE_ODDS: "reference odds",

  //jockeys & trainers
  JOCKEYS_RIDES_FOR_THE_DAY: "jockeys rides for the day",
  TRAINERS_ENTRIES_FOR_THE_DAY: "trainers entries for the day",
  JOCKEY_TRAINER_RANKING: "jockey trainer ranking",

  //reference info
  CHANGES: "changes",
  EXPERT_COLUMN: "expert column",
  GENERAL_INFORMATION: "general information",
  RACING_STATISTICS: "racing statistics",
  FORM_GUIDE: "form guide",
  FORM_COMMENT: "form comment",
  TIPSTERS_SELECTION: "tipsters selection",
  TRACK_ANALYSIS: "track analysis",

  RESULTS: "results",

  NEWS: "news",
}

export const fakeLoadingPages = [
  menuTabSet.JOCKEYS_RIDES_FOR_THE_DAY,
  menuTabSet.JOCKEY_TRAINER_RANKING,
  menuTabSet.TRAINERS_ENTRIES_FOR_THE_DAY,
  menuTabSet.TRACK_ANALYSIS,
  menuTabSet.TIPSTERS_SELECTION,
  menuTabSet.RACING_STATISTICS,
  menuTabSet.GENERAL_INFORMATION
]